import { takeEvery } from "redux-saga/effects";
import api from "../../../../utils/apiService";
import { ENDPOINT } from "../../../../config/endpoints";
import { savePosSettings } from "../../../slices/PosSettingsSlice";
import { pollForTickets } from "../../../../effects-bridge";

export * from "./shared";

/**
 * WEB variant of `redux-store/saga/pos/posSettings`. See `./shared.ts` for the one-line
 * divergence that keeps this out of the shared file.
 *
 * ⚠️ `pollForTickets` comes from the EFFECTS BRIDGE. Behind it sits a 900-line `utils/polling`
 * that imports `helper/printHelper` — printer hardware core cannot own. The bridge entry is debt
 * by design; see effects-bridge.ts.
 *
 * ⚠️ The commented-out `getPOSSettingsDataSuccess` dispatch is the app's own and is preserved:
 * the save deliberately does NOT write the response back into state, because the caller's
 * callback re-reads settings itself.
 */
function* savePOSSettings(action: any): any {
  try {
    const response = yield api.request({
      method: 'PUT',
      url: ENDPOINT.POS.getPOSSettings(),
      data: action.payload.dataToPost
    })
    // yield put(getPOSSettingsDataSuccess({ response }));
    action.payload.callback && action.payload.callback(true);
    pollForTickets()
    // callWorker()
  } catch (error) {
    action.payload.callback && action.payload.callback(false);
    console.log(error);
  }
}

export default function* root(): any {
  yield takeEvery(savePosSettings.type, savePOSSettings);
}
